export default __webpack_public_path__ + "static/media/premium-red-light-district.b49c3960.png";